export class YandexMetrika {
    track(code, eventCode) {
        try {
            window.ym(911516, code, eventCode);
        } catch (e) {
            //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
        }
    }

    timeClient() {
        this.track('reachGoal', 'time_more_than_x');
    }

    orderComplete() {
        this.track('reachGoal', 'order_complete');
    }
}


// WEBPACK FOOTER //
// ./blocks/tracker/yandex-metrika.js